<template>
  <dialog-form
    :show-dialog="isShowDialog"
    @cancel="hideDialog"
    @submit="submit"
  >
    <template #title>
      <p>Add Reason for Long-Distance Pickup</p>
    </template>

    <p class="align-items-center mb-10">
      Please ask why the ride pickup is over 100 miles away from the user's home address and enter it below
    </p>

    <sanitized-textarea v-model="note" />

    <template #submit-button>
      Submit
    </template>
  </dialog-form>
</template>

<script lang="ts">
import { ref } from 'vue';
import { clickSectionEditButton, scrollToElement } from '@/Utils/util';
import { useCustomer } from '@/use/customer';
const { add100MilesNoteToOperatorNote } = useCustomer();
export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
  },

  setup: (props: any, context: any) => {
    const { emit } = context;

    const note = ref('');
    const hideDialog = () => {
      emit('hideDialog');
    };

    const submit = () => {
      add100MilesNoteToOperatorNote(note.value);
      clickSectionEditButton('generalInfo');
      scrollToElement('#general-info');
      hideDialog();
    };

    return {
      hideDialog,
      submit,
      note,
    };
  },
};
</script>
